import { render, staticRenderFns } from "./settlement.vue?vue&type=template&id=83ad11e0"
import script from "./settlement.vue?vue&type=script&lang=js"
export * from "./settlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ad11e0')) {
      api.createRecord('83ad11e0', component.options)
    } else {
      api.reload('83ad11e0', component.options)
    }
    module.hot.accept("./settlement.vue?vue&type=template&id=83ad11e0", function () {
      api.rerender('83ad11e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/settlement.vue"
export default component.exports